
import { formatMoney } from 'helpers';
import styles from './Text.module.scss';
import cx from 'classnames';
export interface IText {
  type?: string;
  bold?: boolean;
  textAlign?: 'left' | 'center' | 'right' | 'unset' | 'justify';
  textTransform?:
    | 'none'
    | 'capitalize'
    | 'uppercase'
    | 'lowercase'
    | 'full-width'
    | 'full-size-kana';
  truncate?: boolean;
  margin?: string;
  onClick?: () => void;
  children: string;
  width?: any;
  color?: string;
  fontSize?: string;
  fontWeight?: string;
}

const Text: React.FC<IText> = ({
  bold = false,
  children,
  type = 'primary',
  textAlign ,
  width = '100%',
  fontSize ,
  fontWeight ,
  color,
  ...rest
}) => {
  return(
  <p
    style={{
      textAlign: textAlign,
      width: width,
      color: color ?? '',
      fontSize: fontSize,
      fontWeight: fontWeight
    }}
    className={cx({
      [styles.primary] : type === 'primary',
      [styles.secondary] : type === 'secondary',
      [styles.small] : type === 'small',
      [styles.smaller] : type === 'smaller',
      [styles.currency] : type === 'currency',
      [styles.header] : type === 'header',
      [styles.smallHeader] : type === 'smallHeader',
      [styles.big] : type === 'big',
      [styles.sidebarHeader] : type === 'sidebarHeader',
      [styles.bold] : bold,
    }, styles.default)}
    {...rest}
  >
    {(type === 'currency')? formatMoney(children) : children}
  </p>)
}

export default Text;